const CHROME_WEB_STORE_URL =
  'https://chromewebstore.google.com/detail/cara-smart-fill/epmjppbjijdocdaaabiaamkhmndboppj?authuser=0&hl=en';

// Short enough that a page opened after the answer still has the click's user
// activation, which Chrome needs to allow a new tab.
const PANEL_ANSWER_MS = 2_000;

export type SmartFillPanelOutcome = 'opened' | 'failed' | 'missing';

const isInstalled = () => Boolean(document.querySelector('[data-cara-smart-fill]'));

const openWebStore = () => window.open(CHROME_WEB_STORE_URL, '_blank', 'noopener,noreferrer');

const postRequest = (requestId: string, workspaceId: string, action: 'OPEN' | 'GENERATE') =>
  window.postMessage(
    { source: 'cara-web', type: 'CARA_SMART_FILL_REQUEST', requestId, action, workspaceId },
    window.location.origin
  );

export function launchSmartFillExtension(workspaceId: string, action: 'OPEN' | 'GENERATE'): void {
  if (!isInstalled()) {
    openWebStore();
    return;
  }
  postRequest(crypto.randomUUID(), workspaceId, action);
}

/**
 * Opens the Smart Fill side panel and waits for the extension to answer, or opens
 * the Chrome Web Store when the extension is not installed. The panel opens on
 * its workspaces: the extension takes no bucket from Cara.
 */
export function openSmartFillSidePanel(workspaceId: string): Promise<SmartFillPanelOutcome> {
  if (!isInstalled()) {
    openWebStore();
    return Promise.resolve('missing');
  }
  const requestId = crypto.randomUUID();
  return new Promise((resolve) => {
    const finish = (outcome: SmartFillPanelOutcome) => {
      window.removeEventListener('message', receive);
      window.clearTimeout(timer);
      resolve(outcome);
    };
    const receive = (event: MessageEvent) => {
      const answer = event.data as {
        source?: unknown;
        type?: unknown;
        requestId?: unknown;
        ok?: unknown;
      };
      if (
        event.source !== window ||
        event.origin !== window.location.origin ||
        answer?.source !== 'cara-smart-fill-extension' ||
        answer.type !== 'CARA_SMART_FILL_RESPONSE' ||
        answer.requestId !== requestId
      ) {
        return;
      }
      finish(answer.ok === true ? 'opened' : 'failed');
    };
    const timer = window.setTimeout(() => finish('failed'), PANEL_ANSWER_MS);
    window.addEventListener('message', receive);
    postRequest(requestId, workspaceId, 'OPEN');
  });
}
